import { useContext } from "react";
import { ScheduleDraftEditorWorkspaceContext } from "../context/ScheduleDraftEditorWorkspaceContext";

export function useScheduleDraftEditorWorkspace() {
    const context = useContext(ScheduleDraftEditorWorkspaceContext);

    if (!context) {
        throw new Error("useScheduleDraftEditorWorkspace 必须在 ScheduleDraftEditorWorkspaceProvider 内使用");
    }

    return context;
}

export default useScheduleDraftEditorWorkspace;
